import { ArityScope } from '@/types/arity';
import { Detail } from '@/types/detail';
import { ListParameter } from '@/types/metadata/metadata';
import { ValidationError } from '@/types/validation';
import { listArity } from '@/util/arity';
import { isArray, isNullOrUndefined } from '@/util/typeGuards';

/**
 * An arity bound list must be exactly as long as its interface — nothing fills a short one in on load. An
 * absent list is an error only once the interface declares rows, since zero declared rows carry no values.
 */
export const validateListArity = (
  parameter: ListParameter,
  values: Detail | undefined,
  nodeId: number,
  blockName: string,
  scope: ArityScope
): ValidationError[] => {
  const arity = listArity(parameter, values, nodeId, scope);
  if (isNullOrUndefined(arity)) return [];

  const stored = values?.[parameter.value];
  if (isNullOrUndefined(stored) && arity === 0) return [];
  if (isArray(stored) && stored.length === arity) return [];

  const handler = parameter.event_name ? ` under event handler ${parameter.event_name}` : '';
  return [
    {
      severity: 'error',
      message: isArray(stored)
        ? `Block ${blockName} has ${stored.length} ${parameter.label}${handler} but its interface declares ${arity}`
        : `Block ${blockName} is missing its ${parameter.label} list${handler}`,
      id: nodeId
    }
  ];
};
